export const isEvaluationNearZero = (evaluation: number) =>
	Math.abs(evaluation) < 0.01;
